import type { SystemEntityStore } from './registry';

type SystemEntityStoreResolver = () => SystemEntityStore | null;

let resolveSystemEntityStore: SystemEntityStoreResolver = () => null;

/** Intended for the composition root and test harnesses. */
export function setSystemEntityStoreResolver(resolver: SystemEntityStoreResolver): void {
	resolveSystemEntityStore = resolver;
}

/** App-lifetime store for system-scoped entities; workspace collections are deliberately absent. */
export function useSystemEntityStore(): SystemEntityStore {
	const store = resolveSystemEntityStore();

	if (!store) {
		throw new Error('System entity store is unavailable before the application is initialized');
	}

	return store;
}
